import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchCmsMetaData } from "../Components/Utility/cmsMetaService";
import ReviewSlider from "../Components/Utility/ReviewSlider";
import { SetMetaTags } from "../Components/Utility/setMetaTags";
import LoginModal from "./Users/LoginModal";

function Review() {

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // get the base64-encoded values
  const encodedHid = searchParams.get("hid");
  const encodedEid = searchParams.get("eid");
  const encodedBid = searchParams.get("bid");
  const navigate = useNavigate();
   const [loginOpen, setLoginOpen] = useState(false);
   const [meta,setMeta] = useState();


  

  // decode Base64 safely
  const decodeBase64 = (str) => {
    try {
      return atob(str); // built-in Base64 decoder
    } catch (err) {
      console.error("Invalid Base64 string", str);
      return null;
    }
  };

  const hid = decodeBase64(encodedHid);
  const eid = decodeBase64(encodedEid);
  const bid = decodeBase64(encodedBid);

  
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [review, setReview] = useState("");
  const [loading, setLoading] = useState(false);

    const [reviews, setReviews] = useState([]);
  const [averageRating, setAverageRating] = useState(0);
  const [reviewsCount, setReviewsCount] = useState(0);
  const [baseUrl, setBaseUrl] = useState("");
 

  const breakdown = {
    5: 90,
    4: 60,
    3: 40,
    2: 30,
    1: 8,
  };



  // Token and user validation (inside useEffect to avoid render errors)
  useEffect(() => {


  const token = localStorage.getItem("authToken");
  const storedUser = localStorage.getItem("user");

 if (hid && eid) {
  const safeHid = String(hid).trim();
  const safeEid = String(eid).trim();
  localStorage.setItem("pendingHid", safeHid);
  localStorage.setItem("pendingEid", safeEid);
  
}

  

  if (!token || !storedUser) {
    setLoginOpen(() => true);
    return;
  }

  try {
    const user = JSON.parse(storedUser);

    if (user.user_type !== 1) { 
      toast.error("You are not able to give Review")
      navigate("/");
      return;
    }

  } catch (error) {
    console.error("❌ Error parsing user from localStorage:", error);
    setLoginOpen(true);
  }
}, []);

useEffect(() => {
  console.warn("👀 loginOpen state changed:", loginOpen);
}, [loginOpen]);

useEffect(() => {
  let lastToken = localStorage.getItem("authToken");

  const checkToken = () => {
    const currentToken = localStorage.getItem("authToken");
    if (currentToken && currentToken !== lastToken) {
      window.location.reload(); // Reload once after login/OTP
    }
    lastToken = currentToken;
  };

  // Check every 1 second
  const interval = setInterval(checkToken, 1000);

  // Cleanup
  return () => clearInterval(interval);
}, []);





  

useEffect(() => {
    fetchReviews();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
 
  }, []);

   


  const fetchReviews = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_BASE}/user/getExperienceReviews/${eid}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (data?.status) {
        setReviews(data.data.reviews || []);
        setAverageRating(data.data.average_rating || 0);
        setReviewsCount(data.data.reviews_count || 0);
        setBaseUrl(data.base_url);
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
    }
  };


 const handleSubmit = async (e) => {
  e.preventDefault();

  const token = localStorage.getItem("authToken");
  const storedUser = localStorage.getItem("user");

  // 🧩 1️⃣ Prevent API call if not logged in
  if (!token || !storedUser) {
    toast.error("Please login to submit a review.");
    setLoginOpen(true);
    return;
  }

   const user = JSON.parse(storedUser);

    if (user.user_type !== 1) { 
      toast.error("You are not able to give Review")
      navigate("/")
      return;
    }


  try {
    setLoading(true);
    const payload = {
      host_id: hid,
      experience_id: eid,
      booking_id: bid,
      description: review,
      rating,
    };

    const { data } = await axios.post(
      `${process.env.REACT_APP_API_BASE}/user/addHostReview`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    // 🧩 2️⃣ Handle backend “Unauthenticated” message (even if 200 but failed)
    if (data?.status === false && data?.message?.includes("Unauthenticated")) {
      toast.error(data.message || "Please login first.");
      setLoginOpen(true);
      return;
    }

    // 🧩 3️⃣ Handle success
    toast.success("Reviewed successfully ✅");
    setReview("");
    setRating(0);
    navigate("/");
  } catch (error) {
    console.error("❌ Error submitting review:", error);

    // 🧩 4️⃣ Handle real API error message if available
    const apiMsg =
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong.";

    toast.error(apiMsg); // ✅ show API's real message

    // 🧩 5️⃣ If it’s authentication error, reopen login popup
    if (
      error?.response?.status === 401 ||
      apiMsg.includes("Unauthenticated")
    ) {
      setLoginOpen(true);
    }
  } finally {
    setLoading(false);
  }
};


   const renderStars = () => {
    const fullStars = Math.floor(averageRating);
    const halfStar = averageRating % 1 !== 0;
    const stars = [];

    for (let i = 1; i <= fullStars; i++) {
      stars.push(<i key={`full-${i}`} className="fa fa-star"></i>);
    }

    if (halfStar) {
      stars.push(<i key="half" className="fa fa-star-half-o"></i>);
    }

    for (let i = stars.length + 1; i <= 5; i++) {
      stars.push(<i key={`empty-${i}`} className="fa fa-star-o"></i>);
    }

    return stars;
  };

  // Inside your Review component:

// helper
const getBreakdown = (reviews) => {
  const counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
  reviews.forEach((rev) => {
    const r = Math.round(Number(rev.rating));
    if (counts[r] !== undefined) counts[r]++;
  });
  const total = reviews.length || 1;
  for (let star = 1; star <= 5; star++) {
    counts[star] = (counts[star] / total) * 100;
  }
  return counts;
};

const breakdownPercent = getBreakdown(reviews);


// 🧹 Cleanup on unmount
useEffect(() => {
  return () => {
   
    localStorage.removeItem("pendingHid");
    localStorage.removeItem("pendingEid");
  };
}, []);

 useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("review");
      setMeta(data);
    };

    loadMeta();
  }, []);



  
  
  return (
    <>
    <section className="ser_v_araeea reviewss">

       <SetMetaTags
        title= {meta?.meta_title || "Review | Weyfarin"}
        description={meta?.meta_description || "Review | Weyfarin"}
      
      />
      <div className="container">
        <div className="row">
          {/* Left Side - Average Rating */}
        
		  <div className="col-lg-6">
  <div className="rv_tx_areaa">
    <h4>Average Rating</h4>
    <p className="adreviess">
      <span className="ratings">
        {averageRating}/5 ({reviewsCount} reviews)
      </span>{" "}
      {renderStars()}
    </p>

    <div className="ad_skilss">
      {Object.keys(breakdownPercent)
        .reverse() // show 5 star first
        .map((star) => (
          <div key={star} className="skill_bar">
            <span className="lbl">{star}</span>
            <div className="progress">
              <div
                className="progress-bar"
                style={{ width: `${breakdownPercent[star]}%` }}
              ></div>
            </div>
            <span className="percent">
              {Math.round(breakdownPercent[star])}%
            </span>
          </div>
        ))}
    </div>
  </div>
</div>


          {/* Right Side - Submit Review */}
          <div className="col-lg-6">
            <div className="rv_tx_areaa brd">
              <h4>Submit your Review</h4>
              <div className="adreviess">
                <p>Add your Rating</p>
                {[1, 2, 3, 4, 5].map((star) => (
                  <i
                    key={star}
                    className={`fa ${
                      star <= (hover || rating) ? "fa-star" : "fa-star-o"
                    }`}
                    
                    onClick={() => setRating(star)}
                    onMouseEnter={() => setHover(star)}
                    onMouseLeave={() => setHover(rating)}
                  />
                ))}
              </div>

              <form onSubmit={handleSubmit}>
                <div className="frm_writs">
                  <div className="form-group">
                    <label>Write your review</label>
                    <textarea
                      className="form-control"
                      placeholder="Write your review"
                      rows="4"
                      value={review}
                      onChange={(e) => setReview(e.target.value)}
                      required
                    ></textarea>
                  </div>
                  <div className="submmit">
                    <button type="submit" className="submmits">
                      Submit Review
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Other Reviews Section */}

		<ReviewSlider reviews={reviews} baseUrl={baseUrl} />
       
      </div>
    </section>

    
   
    <LoginModal isOpen={loginOpen} onClose={() => setLoginOpen(false)} />

  

    </>
  );
}

export default Review;
